import React from 'react'
import image from '../../assets/homepage_ps1.png'
import image2 from '../../assets/homepage_ps2.png'
import image3 from '../../assets/homepage_ps3.png'
import image4 from '../../assets/homepage_ps4.png'
const LatestProduct = () => {
    const products = [
        {
            "id": 1,
            "name": "Headphone 1",
            "author": "Charles Duhigg",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 2,
            "name": "Headphone 2",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image2
        },
        {
            "id": 3,
            "name": "Headphone 3",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image3
        },
        {
            "id": 4,
            "name": "Headphone 4",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image4
        },
    ]
    return (
        <>
            <>
                <h2 className="title1 mt-4">Latest Products</h2>
                <ul className="pro-lst">
                    {products.map((i,index)=>(
                    <li key={index}>
                        <div className="bx-img">
                            <img className="img-fluid" src={i.image} alt="" />
                        </div>
                        <div className="prod-txt">
                            <a href="#">
                                <h3>Vantech VP-153C Camera</h3>
                                <h4>
                                    $195.00 <span>$229.99</span>
                                </h4>
                            </a>
                        </div>
                    </li>
                     ))}
                </ul>
            </>

        </>
    )
}

export default LatestProduct